import { render, staticRenderFns } from "./packageCard.vue?vue&type=template&id=759eed7a&"
import script from "./packageCard.vue?vue&type=script&lang=js&"
export * from "./packageCard.vue?vue&type=script&lang=js&"
import style0 from "./packageCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports